import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-btn',
    templateUrl: './button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonComponent implements OnInit {
  @Input() type?: string = 'button';
  @Input() color?: string
  @Input() class?: string;
  @Input() loading?: boolean = false;
  @Input() disabled?: boolean;
  @Input() activeClass?: string;

  @Output() onAction = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  action() {
    this.onAction.emit();
  }
}
